import { RootState } from '@/shared/store'

import { runsheetShiftTablesAdapter } from '../adapters/runsheetShiftTablesAdapter'

export const runsheetShiftTablesSelector = runsheetShiftTablesAdapter.getSelectors<RootState>(
  (state) => state.runsheetShiftTables,
)
